export interface ColumnMapping {
  refColumn: string;
  quarterColumns: Record<string, string>;   // header -> '2026-Q3'
}
// No `kind` column. The catalog's row kind (component / chassis / labor /
// baseRemainder) is never sourced from the sheet — import does not create
// components, so the kind is always already known from the component's
// existing rows. A field set here and read nowhere is how `isLatest` became
// misleading; don't add a second one.

const PATTERNS: RegExp[] = [
  /^Q([1-4])[\s-]*(\d{4})$/i,      // Q1 2026, Q1-2026
  /^(\d{4})[\s-]*Q([1-4])$/i,      // 2026 Q1, 2026-Q1, 2026Q1
];

/** '<header>' -> '2026-Q1', or null when it is not a quarter column. */
export function headerToQuarter(header: string): string | null {
  const h = header.trim();
  for (const [i, re] of PATTERNS.entries()) {
    const m = re.exec(h);
    if (!m) continue;
    const [q, y] = i === 0 ? [m[1]!, m[2]!] : [m[2]!, m[1]!];
    return `${y}-Q${q}`;
  }
  return null;
}

const REF_HEADER_RE = /^(sku|component|part|part\s*(number|no\.?)|partnumber|pn|vdura\s*pn|ref)$/i;

export function inferMapping(headers: string[]): ColumnMapping {
  const quarterColumns: Record<string, string> = {};
  // First NON-BLANK header: an Excel export routinely leads with empty cells.
  let refColumn = headers.find((h) => h.trim() !== '') ?? '';

  for (const h of headers) {
    const quarter = headerToQuarter(h);
    if (quarter) { quarterColumns[h] = quarter; continue; }
    if (REF_HEADER_RE.test(h.trim())) refColumn = h;
  }
  return { refColumn, quarterColumns };
}
